import {
  Button,
  Divider,
  Group,
  NumberFormatter,
  Paper,
  Stack,
  Text,
} from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useNavigate } from "react-router-dom";
import { IconExternalLink } from "@tabler/icons-react";

const ArgumentsDatabase = ({ item, isHistory }) => {
  const lang = useLanguage((s) => s.language);
  const navigate = useNavigate()

  const handleFilter = () => {
    const encodedFilters = encodeURIComponent(JSON.stringify(item?.arguments?.filtersInputs || []));
    navigate(`/contact-lists/import?type=database&initialFilters=${encodedFilters}`);
  }

  const Wrapper = ({ children }) =>
    isHistory ? (
      <Paper component={Stack} gap={"xs"} radius={"md"} bg={"gray.1"} p={"md"}>
        {" "}
        {children}{" "}
      </Paper>
    ) : (
      <Stack mt={"xs"} gap={"xs"}>
        {children}
      </Stack>
    );

  return (
    <Wrapper>
      <Text>
        {lang.contact_lists.jobs.completed.max_profiles}{" "}
        <b>
          <NumberFormatter value={item?.arguments?.maxResults} />
        </b>
      </Text>
      <Divider w={"50%"} />
      <Stack gap={4}>
        {/* <Text mr={"xs"}>Critères de recherches</Text> */}
        <Stack gap={4}>
          {item?.arguments?.filtersInputs?.map((filter) => {
            let condition = Object.keys(filter)[1];
            let values = Array.isArray(filter[condition])
              ? filter[condition].join(", ")
              : filter[condition];

            if (condition === "does_not_contain") {
              condition = "not_contains";
            }

            let conditionLabel =
              lang.table.toolbar.filter.filters_list_label.server?.[
              condition
              ] || condition;

            // if (conditionLabel === "does_not_contain") {
            //   conditionLabel = lang.table.toolbar.filter.filters_list_label.client
            // }

            let fieldLabel =
              lang.database.fields?.[filter.field] || filter.field;

            return (
              <>
                <Group key={filter.field} mt={"sm"}>
                  <Text fw={600} c={"primary"}> {fieldLabel} </Text>
                  <Text fw={600}>{conditionLabel}</Text>
                </Group>
                <Text>{values}</Text>
              </>
            );
          })}
        </Stack>
      </Stack>

      {
        item?.arguments?.filtersInputs &&
        <Button onClick={handleFilter} variant="light" rightSection={<IconExternalLink size={18} />}>
          {lang.database.view_filter_results}
        </Button>
      }
    </Wrapper>
  );
};

export default ArgumentsDatabase;
